import { Link } from 'react-router-dom';
import wordmarkSrc from '@/assets/branding/wordmark.png';

export default function LandingNav() {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 lg:px-8"
      style={{
        background: 'rgba(6, 9, 15, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--color-border-subtle)',
      }}
    >
      {/* Brand: official wordmark image */}
      <Link
        to="/"
        aria-label="PointeTracer home"
      >
        <img
          src={wordmarkSrc}
          alt="PointeTracer"
          style={{ height: '56px', width: 'auto', objectFit: 'contain' }}
        />
      </Link>

      {/* Right-side actions */}
      <nav className="flex items-center gap-3" aria-label="Site navigation">
        <Link
          to="/login"
          className="inline-flex items-center justify-center rounded-lg px-5 py-2 text-sm font-semibold transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          style={{
            backgroundColor: 'var(--color-brand-primary)',
            color: 'var(--color-text-inverse)',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor =
              'var(--color-brand-primary-hover)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor =
              'var(--color-brand-primary)';
          }}
        >
          Sign in
        </Link>
      </nav>
    </header>
  );
}
